import { render } from "./SvgIcon.vue?vue&type=template&id=34dd50be"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=34dd50be&lang=scss"

import exportComponent from "/Users/gj/Documents/projects/zwrtwt/zwit-planner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__